var map = {
	"./images/BasketballShootingRace.png": 7990,
	"./images/CardMatchGame.png": 6380,
	"./images/DungeonCommand.png": 4018,
	"./images/ExplodingElves.png": 994,
	"./images/TileMatchingGame.png": 6888,
	"./images/profile.jpg": 1120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5488;